import React from 'react'
import About from '../components/About/About'
import NavAfterLogin from '../components/Navbar/NavAfterLogin'

const AboutPage = () => {
  return (
    <>
      <NavAfterLogin />
      <About />
    </>
  )
}

export default AboutPage